module.exports = __webpack_public_path__ + "img/logo_border.e16ae1bb.png";